import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeToLocaleDateString',
    standalone: false
})
export class TimeToLocaleDateStringPipe implements PipeTransform {

    transform(time: number): string {
        return new Date(time).toLocaleDateString();
    }

}
